<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-card>
      <v-card-text class="pa-5">
        <v-card v-if="statistic.indicators">
          <v-card-title>
            <v-row align="center">
              <v-col cols="2">
                Общая статистика
              </v-col>
              <v-col>
                <v-autocomplete :items="sourceList" v-model="selectedSources" multiple chips deletable-chips>
                  <template v-slot:prepend-item>
                    <v-list-item ripple @mousedown.prevent @click="selectedSourcesToggle">
                      <v-list-item-action>
                        <v-icon :color="selectedSources.length > 0 ? 'primary' : ''">
                          {{ autoCompleteIcon }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          Выбрать всё
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"/>
                  </template>
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index < 3">
                      <span>{{ item }}</span>
                    </v-chip>
                    <span
                      v-if="index === 3"
                      class="grey--text text-caption"
                    >
                      (+{{ selectedSources.length - 3 }} других)
                   </span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col>
                <v-dialog
                  ref="dialog"
                  v-model="dateDialog"
                  :return-value.sync="date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date"
                      label="Выберите промежуток"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="date"
                    range
                    scrollable
                    locale="ru-RU"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="dateDialog = false"
                    >
                      Закрыть
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog.save(date)"
                    >
                      Oк
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
        <v-card class="mt-5" v-if="statistic.indicators">
          <v-card-title>
            <h2>Основные показатели</h2>
          </v-card-title>
          <v-card-text>
            <div>
              <v-row>
                <v-col offset="1">
                  <div class="text text-subtitle-1">Пользователи</div>
                  <div class="h2">{{ statistic.indicators.Users }}</div>
                </v-col>
                <v-col>
                  <div class="text text-subtitle-1">Просмотры страниц</div>
                  <div class="h2">{{ statistic.indicators.Hits }}</div>
                </v-col>
                <v-col>
                  <div class="text text-subtitle-1">Сред. длительность сеанса</div>
                  <div class="h2">{{ statistic.indicators.AvgVisitDuration }}</div>
                </v-col>
                <v-col>
                  <div class="text text-subtitle-1">Показатель отказов</div>
                  <div class="h2">{{ statistic.indicators.BounceRate }}%</div>
                </v-col>
              </v-row>
              <v-row>
                <v-col offset="1">
                  <div class="text text-subtitle-1">Сеансы</div>
                  <div class="h2">{{ statistic.indicators.Visits }}</div>
                </v-col>
                <v-col>
                  <div class="text text-subtitle-1">Страниц/сеанс</div>
                  <div class="h2">{{ statistic.indicators.AvgPagePerSession }}</div>
                </v-col>
                <v-col>
                  <div class="text text-subtitle-1">Ср. длительность просмотра стр.</div>
                  <div class="h2">{{ statistic.indicators.AvgPageDuration }}</div>
                </v-col>
                <v-col>
                  <div class="text text-subtitle-1">Длительность сеанса</div>
                  <div class="h2">{{ statistic.indicators.TotalDuration }}</div>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
        <v-card class="mt-5" v-show="statistic.user_graphic">
          <v-card-title>
            Пользователи
          </v-card-title>
          <v-card-text>
              <div>
                <apexchart ref="firstChar" type="line" height="320" :options="userChartOptions" :series="userChartSeries"/>
              </div>
              <div>
                <apexchart ref="secondChar" type="line" height="320" :options="userPreviousChartOptions" :series="userPreviousChartSeries"/>
              </div>
          </v-card-text>
        </v-card>
        <v-card class="mt-5">
          <v-row>
            <v-col v-if="statistic.trafic">
              <v-card-title>
                Распределение по каналам трафика
              </v-card-title>
            </v-col>
            <v-col v-if="statistic.devices">
              <v-card-title>
                Устройства
              </v-card-title>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="statistic.trafic">
              <apexchart type="bar" height="350" :options="statistic.trafic.options" :series="statistic.trafic.series"/>
            </v-col>
            <v-col v-if="statistic.devices">
              <apexchart type="donut" height="350" :options="statistic.devices.options" :series="statistic.devices.series"/>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-5">
          <v-card-title>
            Регионы пользователей
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="regionsHeaders"
              :items="statistic.regions"
              :items-per-page="10"
            />
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";

export default {
  name: "General",
  data: () => ({
    dateDialog: false,
    date: [],
    regionsHeaders: [
      { text: 'Регион', value: 'RegionCity' },
      { text: 'Пользователи', value: 'Users' },
      { text: 'Просмотры страниц', value: 'PageViews' },
    ],
    selectedSources: [],
    page: {
      title: "Общая статистика"
    },
    breadcrumbs: [
      {
        text: "Админ панель",
        disabled: false,
        to: '/'
      },
      {
        text: "Статистика",
        disabled: true,
        to: '/'
      },
      {
        text: "Общая статистика",
        disabled: true,
        to: '/statisticsV2/general'
      },
    ],
  }),
  async created() {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() < 9 ? `0${currentDate.getMonth() + 1}` : currentDate.getMonth() + 1;
    const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0)

    this.date = [
      `${lastDay.getFullYear()}-${currentMonth}-01`,
      `${lastDay.getFullYear()}-${currentMonth}-${lastDay.getDate()}`
    ];

    await this.fetch(this.payload)
  },
  computed: {
    ...mapGetters({
      "statistic": "Statistics/getGeneralStatistic",
    }),
    payload() {
      return {
        interval: {
          from: this.date[0],
          to: this.date[1],
        },
        list: this.selectedAllSources ? '' : this.selectedSources,
      }
    },
    sourceList() {
      if (this.statistic.sourceList) {
        return this.statistic.sourceList;
      }

      return [];
    },
    selectedAllSources() {
      return this.sourceList.length === this.selectedSources.length;
    },
    likesSomeSources() {
      return this.selectedSources.length > 0 && !this.selectedAllSources;
    },
    autoCompleteIcon() {
      if (this.selectedAllSources) return 'mdi-close-box'
      if (this.likesSomeSources) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline';
    },
    userChartSeries() {
      const series = this.statistic?.user_graphic?.currentIntervalData;
      if (series) {
        return [
          series,
        ]
      } else {
        return [];
      }
    },
    userPreviousChartSeries() {
      const series = this.statistic?.user_graphic?.previousIntervalData;
      if (series) {
        return [
          series,
        ]
      } else {
        return [];
      }
    },
    userChartOptions() {
      return {
        chart: {
          id: 'current',
          group: 'users',
          type: 'line',
          height: 320,
        },
        title: {
          text: 'Текущий период',
          align: 'left',
        },
        colors: ['#008FFB'],
        xaxis: {

        }
      }
    },
    userPreviousChartOptions() {
      return {
        chart: {
          id: 'previous',
          group: 'users',
          type: 'line',
          height: 320,
        },
        title: {
          text: 'Предыдущий месяц текущего периода',
          align: 'left',
        },
        colors: ['#00FF66FF'],
        xaxis: {

        }
      }
    }
  },
  methods: {
    ...mapActions({
      "fetch": "Statistics/fetchGeneralStatistic",
    }),
    selectedSourcesToggle() {
      this.$nextTick(() => {
        if (this.selectedAllSources) {
          this.selectedSources = [];
        } else {
          this.selectedSources = this.sourceList;
        }
      })
    },
    formatDate(date) {
      const currentMonth = date.getMonth() < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
      const currentDay = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
      return `${date.getFullYear()}-${currentMonth}-${currentDay}`
    }
  },
  watch: {
    date: {
      async handler() {
        if (this.date.length === 2) {
          const firstDate = new Date(this.date[0]);
          const secondDate = new Date(this.date[1]);

          if (firstDate > secondDate) {
            this.date[0] = this.formatDate(secondDate);
            this.date[1] = this.formatDate(firstDate);
          }

          await this.fetch(this.payload)
        }
      }
    },
    selectedSources: {
      async handler() {
        await this.fetch(this.payload);
      }
    },
    statistic: {
      handler() {
          if(this.statistic.user_graphic) {
          // eslint-disable-next-line no-undef
            ApexCharts.exec('current', 'updateOptions', {
              xaxis: {
                categories: this.statistic?.user_graphic?.currentInterval
              }
            });
            // eslint-disable-next-line no-undef
            ApexCharts.exec('previous', 'updateOptions', {
              xaxis: {
                categories: this.statistic?.user_graphic?.previousInterval,
              }
            })
          }
      },
      deep: true,
      immediate: true,
    }
  }
}
</script>

<style scoped>

</style>
